import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, AbstractControl } from '@angular/forms';
import { AppService } from 'src/app/services/app.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-lost-pw-page',
  templateUrl: './lost-pw-page.component.html',
  styleUrls: ['./lost-pw-page.component.scss']
})
export class LostPwPageComponent implements OnInit {
  public email: string;
  public status: 'PENDING' | 'VALIDATING' = 'PENDING';
  public emailNotFound = false;

  public emailFormControl: FormControl;
  public emailFormSubscription: Subscription;

  constructor(private app: AppService) {

  }

  ngOnInit(): void {
    this.emailFormControl = new FormControl(this.email, [
      Validators.required,
      Validators.email,
      (c: AbstractControl) => {
        if (!this.emailNotFound) {
          return null;
        } else {
          return {
            found: {
              valid: false
            }
          };
        }
      }
    ]);
  }

  public onSubmit(): void {
    this.app.dialog.loader({ title: 'Fordere neue Passwort an' });
    this.status = 'VALIDATING';
    this.emailFormControl.updateValueAndValidity();
    this.email = this.emailFormControl.value;
    this.app.lostPassword(this.email).then(() => {
      setTimeout(() => {
        this.app.dialog.closeLoader();
        this.app.router.navigateByUrl('neues-passwort/angefordert', {
          params: {
            type: 'PW_REQUEST',
            returnType: 'SIGN_IN',
            email: this.email
          }
        });
      }, 1000);
    }).catch(() => {
      setTimeout(() => {
        this.app.dialog.closeLoader();
        this.emailNotFound = true;
        this.emailFormControl.markAllAsTouched();
        this.emailFormControl.markAsDirty();
        this.emailFormControl.updateValueAndValidity();
        this.status = 'PENDING';
        this.emailFormSubscription = this.emailFormControl.valueChanges.subscribe(() => {
          this.emailNotFound = false;
          this.emailFormControl.markAsPristine();
          this.emailFormSubscription.unsubscribe();
        });
      }, 1000);
    });
  }





}
